import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TOAST_CONFIG } from "../../config/constants";

/**
 * Provider pour la configuration globale des toasts
 */
export default function ToastProvider() {
  return <ToastContainer {...TOAST_CONFIG} />;
}
